<template>
    <div>  
        <el-form :model="form" ref="mainForm" :rules="rules" label-width="auto"> 
            <el-row class="form fill-form">    
                <el-col :span="24" class="form-box">  
                    <el-col class="form-left" :span="12">
                        <div class="form__border-bottom"> 
                            <main-title>Orders generation</main-title>
                        </div> 

                        <div class="form__body"> 
                            <div class="form-item form-item__multiple">
                                <el-col :span="11">
                                    <div class="form-item form-item_mb"> 
                                        <label class="form-item__label">
                                            Number of orders
                                        </label>
                                        <el-form-item prop="orders.quantity">  
                                            <el-input-number 
                                                type="quantity"
                                                class="form-item__number"
                                                :controls="false"
                                                v-model="form.orders.quantity"
                                                placeholder="500" 
                                            ></el-input-number>
                                        </el-form-item> 
                                    </div> 
                                </el-col>
                                <el-col :span="2" class="grid-content"></el-col>
                                <el-col :span="11">
                                    <div class="form-item form-item_mb"> 
                                        <label class="form-item__label">
                                            Orders with 2 handyman
                                        </label>
                                        <el-form-item prop="orders.with_two_masters"> 
                                            <el-input-number 
                                                class="form-item__number"
                                                :controls="false"
                                                v-model="form.orders.with_two_masters"
                                                placeholder="2%"
                                            ></el-input-number>
                                        </el-form-item> 
                                    </div> 
                                </el-col>
                            </div> 

                            <div class="form-item form-item_mb"> 
                                <label class="form-item__label">
                                    Number of handymen 
                                </label>
                                <el-form-item prop="masters.quantity">  
                                    <el-input-number 
                                        class="form-item__number"
                                        :controls="false"
                                        v-model="form.masters.quantity"
                                        placeholder="30"
                                    ></el-input-number>
                                </el-form-item> 
                            </div> 

                            <div class="form-item form-item_mb"> 
                                <label class="form-item__label">
                                    Working time from/till
                                </label>
                                <div class="form-item__content form-item__content_between">
                                    <el-col :span="11" class="grid-content">
                                        <el-form-item prop="masters.working_timesheet.date.from">
                                            <el-date-picker     
                                                type="date" 
                                                placeholder="Pick a date" 
                                                v-model="form.masters.working_timesheet.date.from"
                                                style="width: 100%;"
                                                format="yyyy/MM/dd"
                                                value-format="yyyy-MM-dd"
                                                :pickerOptions="pickerOptions"
                                            ></el-date-picker>
                                        </el-form-item> 
                                    </el-col>
                                    <el-col :span="2" class="grid-content"></el-col>
                                    <el-col :span="11" class="grid-content"> 
                                        <el-form-item prop="masters.working_timesheet.date.to">
                                            <el-date-picker 
                                                type="date" 
                                                placeholder="Pick a date" 
                                                v-model="form.masters.working_timesheet.date.to"
                                                style="width: 100%;"
                                                format="yyyy/MM/dd"
                                                value-format="yyyy-MM-dd"
                                                :pickerOptions="pickerOptions"
                                            ></el-date-picker>
                                        </el-form-item> 
                                    </el-col>
                                </div>
                            </div>  

                            <div class="form-item form-item_mb"> 
                                <label class="form-item__label">
                                    Schedule from/till
                                </label>
                                <div class="form-item__content form-item__content_between">
                                    <el-col :span="11" class="grid-content">
                                        <el-form-item prop="masters.working_timesheet.time.from">
                                            <el-time-select
                                                placeholder="Start time"
                                                v-model="form.masters.working_timesheet.time.from"
                                                :picker-options="{
                                                    start: '08:00',
                                                    step: '01:00',
                                                    end: '19:00'
                                                }">
                                            </el-time-select>
                                        </el-form-item> 
                                    </el-col>
                                    <el-col :span="2" class="grid-content"></el-col>
                                    <el-col :span="11" class="grid-content"> 
                                        <el-form-item prop="masters.working_timesheet.time.to">
                                            <el-time-select
                                                placeholder="End time"
                                                v-model="form.masters.working_timesheet.time.to"
                                                :picker-options="{
                                                    start: '08:00',
                                                    step: '01:00',
                                                    end: '19:00'
                                                }">
                                            </el-time-select>
                                        </el-form-item> 
                                    </el-col>
                                </div>
                            </div>  
                            
                            <div class="form-item form-item_mb  form__border-bottom">
                                <label class="form-item__label">
                                    Order duration from/till
                                </label>

                                <div class="form-item__content form-item__content_between">
                                    <el-col :span="11" class="grid-content">
                                        <el-form-item prop="orders.duration.from">
                                            <el-select  
                                                v-model="form.orders.duration.from"
                                                placeholder="Select"
                                            >
                                                <el-option
                                                    v-for="item in [ 
                                                        {value: 60, label: '01:00'}, 
                                                        {value: 120, label: '02:00'},
                                                        {value: 180, label: '03:00'}
                                                    ]"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>  
                                    </el-col>

                                    <el-col :span="2" class="grid-content"></el-col>

                                    <el-col  :span="11" class="grid-content"> 
                                        <el-form-item prop="orders.duration.to">
                                            <el-select  
                                                v-model="form.orders.duration.to"
                                                placeholder="Select" 
                                                value-key="value" 
                                            >
                                                <el-option
                                                v-for="item in [
                                                    {value: 60, label: '01:00'}, 
                                                    {value: 120, label: '02:00'},
                                                    {value: 180, label: '03:00'}
                                                ]"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                                 >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>  
                                    </el-col>
                                </div>
                                
                            </div>    

                            <div class="form-item form-item__multiple">
                                <el-col :span="11">
                                    <div class="form-item form-item_mb"> 
                                        <label class="form-item__label">
                                            Percent of clients agree to transfer request  
                                        </label>
                                        <div> 
                                            <el-form-item prop="orders.carry_over">
                                                <el-input-number  
                                                        class="form-item__number"
                                                        :controls="false"
                                                        v-model="form.orders.carry_over"
                                                        placeholder="1%"
                                                ></el-input-number>
                                            </el-form-item> 
                                        </div> 
                                    </div> 
                                </el-col>
                      
                                <el-col :span="2" class="grid-content"></el-col>

                                <el-col :span="11">
                                    <div class="form-item form-item_mb"> 
                                        <label class="form-item__label">
                                            Canceled requests by clients
                                        </label>
                                        <div>  
                                            <el-form-item prop="orders.canceled">
                                                <el-input-number  
                                                    class="form-item__number"
                                                    :controls="false"
                                                    v-model="form.orders.canceled"
                                                    placeholder="1%"
                                            ></el-input-number> 
                                            </el-form-item> 
                                        </div> 
                                    </div> 
                                </el-col>
                            </div>  

                            <div class="form-item form-item__multiple"> 
                                <el-col :span="11">
                                    <div class="form-item form-item_mb"> 
                                        <label class="form-item__label">
                                            Handymen absent daily
                                        </label>
                                        <div>  
                                            <el-form-item prop="masters.working_timesheet.not_go_work">
                                                <el-input-number  
                                                    class="form-item__number"
                                                    :controls="false"
                                                    v-model="form.masters.working_timesheet.not_go_work"
                                                    placeholder="1%" 
                                                ></el-input-number>
                                            </el-form-item> 
                                        </div> 
                                    </div> 
                                </el-col> 
                            </div>

                            <div></div>

                            <div class="form-item form-item_mb">  
                                <div class="el-form-item__cta">
                                    <el-button 
                                        class="default-btn"
                                        @click="onSubmit" 
                                    >Create</el-button>
                                    <el-button>Cancel</el-button>
                                </div>
                            </div>
                        </div>  
                    </el-col> 
                    <el-col class="form-left" :span="12">
                        <div class="form__body">    
                            <div class="form-item form-item_mt">
                                <div class="form-item__map">
                                    <img width="100%" height="100%" src="@/assets/map2.png" alt="">
                                </div>
                            </div> 
                            <!-- :error="`${!mastersPercentSum ? mastersError: ''}`" -->
                            <div class="form-item form-item_mb"> 
                                <label class="form-item__label">
                                    Central (in total should be equal to 100)    
                                </label>

                                <div class="form-item__content form-item__content_between form-item__wrap"> 
                                    <el-col :span="11" class="grid-content"> 
                                        <el-form-item prop="masters.areas.area_a.percent" :error="`${showMasterError ? mastersError: ''}`"> 
                                            <el-input-number  
                                                class="form-item__number"
                                                :controls="false"
                                                v-model="form.masters.areas.area_a.percent"
                                                placeholder="20% masters"
                                            ></el-input-number>
                                        </el-form-item>  
                                    </el-col>
                                    <el-col :span="2" class="grid-content"></el-col>
                                    <el-col :span="11" class="grid-content">  
                                        <el-form-item prop="orders.areas.area_a.percent" :error="`${showOrdersError ? ordersError: ''}`">
                                            <el-input-number  
                                                class="form-item__number"
                                                :controls="false"
                                                v-model="form.orders.areas.area_a.percent"
                                                placeholder="25% orders"
                                            ></el-input-number> 
                                        </el-form-item> 
                                    </el-col>   

                                    <el-col :span="11" class="grid-content grid-content_mt">
                                        <el-form-item>
                                            <el-time-select 
                                                v-model="form.orders.areas.area_a.time.from"
                                                placeholder="Start time" 
                                                :picker-options="{
                                                    start: '08:00',
                                                    step: '01:00',
                                                    end: '19:00'
                                                }">
                                            </el-time-select>
                                        </el-form-item> 
                                    </el-col>
                                    <el-col :span="2" class="grid-content grid-content_mt"></el-col>
                                    <el-col :span="11" class="grid-content grid-content_mt">
                                        <el-form-item>
                                            <el-time-select 
                                                v-model="form.orders.areas.area_a.time.to"
                                                placeholder="End time" 
                                                :picker-options="{
                                                    start: '08:00',
                                                    step: '01:00',
                                                    end: '19:00'
                                                }">
                                            </el-time-select>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="11" class="grid-content grid-content_mt">
                                        <el-form-item prop="orders.areas.area_a.coefficient"> 
                                            <el-input-number  
                                                class="form-item__number"
                                                :controls="false"
                                                v-model="form.orders.areas.area_a.coefficient"
                                                placeholder="1 coefficient"
                                            ></el-input-number>
                                        </el-form-item>   
                                    </el-col>
                                </div> 
                            </div>  

                            <div class="form-item form-item_mb"> 
                                <label class="form-item__label">
                                    East (in total should be equal to 100)
                                </label>
                                
                                <div class="form-item__content form-item__content_between form-item__wrap"> 
                                    <el-col :span="11" class="grid-content"> 
                                        <el-form-item prop="masters.areas.area_b.percent" :error="`${showMasterError ? mastersError: ''}`">
                                            <el-input-number  
                                                class="form-item__number"
                                                :controls="false"
                                                v-model="form.masters.areas.area_b.percent"
                                                placeholder="20% masters"
                                            ></el-input-number>
                                        </el-form-item>  
                                    </el-col>
                                    <el-col :span="2" class="grid-content"></el-col>
                                    <el-col :span="11" class="grid-content">  
                                        <el-form-item prop="orders.areas.area_b.percent" :error="`${showOrdersError ? ordersError: ''}`">
                                            <el-input-number  
                                                class="form-item__number"
                                                :controls="false"
                                                v-model="form.orders.areas.area_b.percent"
                                                placeholder="25% orders"
                                            ></el-input-number>
                                        </el-form-item>  
                                    </el-col>   

                                    <el-col :span="11" class="grid-content grid-content_mt">
                                        <el-form-item>
                                            <el-time-select
                                                v-model="form.orders.areas.area_b.time.from"
                                                placeholder="Start time" 
                                                :picker-options="{
                                                    start: '08:00',
                                                    step: '01:00',
                                                    end: '19:00'
                                                }">
                                            </el-time-select>
                                        </el-form-item> 
                                    </el-col>
                                    <el-col :span="2" class="grid-content grid-content_mt"></el-col>
                                    <el-col :span="11" class="grid-content grid-content_mt">
                                        <el-form-item>
                                            <el-time-select 
                                                v-model="form.orders.areas.area_b.time.to"
                                                placeholder="End time" 
                                                :picker-options="{
                                                    start: '08:00',
                                                    step: '01:00',
                                                    end: '19:00'
                                                }">
                                            </el-time-select>
                                        </el-form-item> 
                                    </el-col>

                                    <el-col :span="11" class="grid-content grid-content_mt">
                                        <el-form-item prop="orders.areas.area_b.coefficient"> 
                                            <el-input-number  
                                                class="form-item__number"
                                                :controls="false"
                                                v-model="form.orders.areas.area_b.coefficient"
                                                placeholder="1.5 coefficient"
                                            ></el-input-number>
                                        </el-form-item> 
                                    </el-col>
                                </div> 
                            </div> 

                            <div class="form-item form-item_mb"> 
                                <label class="form-item__label">
                                    Donaustadt (in total should be equal to 100)
                                </label>
                                
                                <div class="form-item__content form-item__content_between form-item__wrap"> 
                                    <el-col :span="11" class="grid-content">  
                                        <el-form-item prop="masters.areas.area_c.percent" :error="`${showMasterError ? mastersError: ''}`">
                                            <el-input-number  
                                                class="form-item__number"
                                                :controls="false"
                                                v-model="form.masters.areas.area_c.percent"
                                                placeholder="20% masters"
                                            ></el-input-number>
                                        </el-form-item>  
                                    </el-col>
                                    <el-col :span="2" class="grid-content"></el-col>
                                    <el-col :span="11" class="grid-content">  
                                        <el-form-item prop="orders.areas.area_c.percent" :error="`${showOrdersError ? ordersError: ''}`">
                                            <el-input-number  
                                                class="form-item__number"
                                                :controls="false"
                                                v-model="form.orders.areas.area_c.percent"
                                                placeholder="25% orders"
                                            ></el-input-number>
                                        </el-form-item>  
                                    </el-col> 
                                        
                                    <el-col :span="11" class="grid-content grid-content_mt">
                                        <el-form-item>
                                            <el-time-select
                                                v-model="form.orders.areas.area_c.time.from"
                                                placeholder="Start time" 
                                                :picker-options="{
                                                    start: '08:00',
                                                    step: '01:00',
                                                    end: '19:00'
                                                }">
                                            </el-time-select>
                                        </el-form-item>
                                         
                                    </el-col>
                                    <el-col :span="2" class="grid-content grid-content_mt"></el-col>
                                    <el-col :span="11" class="grid-content grid-content_mt">
                                        <el-form-item>
                                            <el-time-select
                                                v-model="form.orders.areas.area_c.time.to"
                                                placeholder="End time" 
                                                :picker-options="{
                                                    start: '08:00',
                                                    step: '01:00',
                                                    end: '19:00'
                                                }">
                                            </el-time-select>
                                        </el-form-item> 
                                    </el-col>

                                    <el-col :span="11" class="grid-content grid-content_mt">
                                        <el-form-item prop="orders.areas.area_c.coefficient"> 
                                            <el-input-number  
                                                class="form-item__number"
                                                :controls="false"
                                                v-model="form.orders.areas.area_c.coefficient"
                                                placeholder="2 coefficient"
                                            ></el-input-number>
                                        </el-form-item> 
                                    </el-col>

                                </div> 
                            </div> 
                            <!-- :error="`${!mastersPercentSum ? mastersError: ''}`" -->
                            <div class="form-item form-item_mb"> 
                                <label class="form-item__label">
                                    North (in total should be equal to 100)
                                </label>
                                
                                <div class="form-item__content form-item__content_between form-item__wrap"> 
                                    <el-col :span="11" class="grid-content">  
                                        <el-form-item prop="masters.areas.area_d.percent" :error="`${showMasterError ? mastersError: ''}`">
                                            <el-input-number  
                                                class="form-item__number"
                                                :controls="false"
                                                v-model="form.masters.areas.area_d.percent"
                                                placeholder="20% masters"
                                            ></el-input-number>
                                        </el-form-item>  
                                    </el-col>
                                    <el-col :span="2" class="grid-content"></el-col>
                                    <el-col :span="11" class="grid-content">  
                                        <el-form-item prop="orders.areas.area_d.percent" :error="`${showOrdersError ? ordersError: ''}`">
                                            <el-input-number  
                                                class="form-item__number"
                                                :controls="false"
                                                v-model="form.orders.areas.area_d.percent"
                                                placeholder="25% orders"
                                            ></el-input-number>
                                        </el-form-item>  
                                    </el-col>

                                    <el-col :span="11" class="grid-content grid-content_mt">
                                        <el-form-item>
                                            <el-time-select
                                                v-model="form.orders.areas.area_d.time.from"
                                                placeholder="Start time" 
                                                :picker-options="{
                                                    start: '08:00',
                                                    step: '01:00',
                                                    end: '19:00'
                                                }">
                                            </el-time-select>
                                        </el-form-item> 
                                    </el-col>
                                    <el-col :span="2" class="grid-content grid-content_mt"></el-col>
                                    <el-col :span="11" class="grid-content grid-content_mt">
                                        <el-form-item>
                                            <el-time-select
                                                v-model="form.orders.areas.area_d.time.to"
                                                    placeholder="End time" 
                                                    :picker-options="{
                                                    start: '08:00',
                                                    step: '01:00',
                                                    end: '19:00'
                                                }">
                                            </el-time-select>
                                        </el-form-item> 
                                    </el-col>

                                    <el-col :span="11" class="grid-content grid-content_mt">
                                        <el-form-item prop="orders.areas.area_d.coefficient"> 
                                            <el-input-number  
                                                class="form-item__number"
                                                :controls="false"
                                                v-model="form.orders.areas.area_d.coefficient"
                                                placeholder="1 coefficient"
                                            ></el-input-number>
                                        </el-form-item> 
                                    </el-col>
                                </div> 
                            </div> 

                            <div class="form-item form-item_mb"> 
                                <label class="form-item__label">
                                    South (in total should be equal to 100)
                                </label>
                                
                                <div class="form-item__content form-item__content_between form-item__wrap"> 
                                    <el-col :span="11" class="grid-content">  
                                        <el-form-item prop="masters.areas.area_e.percent" :error="`${showMasterError ? mastersError: ''}`">
                                            <el-input-number  
                                                class="form-item__number"
                                                :controls="false"
                                                v-model="mastersFifth"
                                                placeholder="20% masters" 
                                            ></el-input-number>
                                        </el-form-item>  
                                    </el-col>
                                    <el-col :span="2" class="grid-content"></el-col>
                                    <el-col :span="11" class="grid-content">  
                                        <el-form-item prop="orders.areas.area_e.percent" :error="`${showOrdersError ? ordersError: ''}`">
                                            <el-input-number  
                                                class="form-item__number"
                                                :controls="false"
                                                v-model="ordersFifth" 
                                                placeholder="25% orders"
                                            ></el-input-number>         
                                        </el-form-item>  
                                    </el-col>
                                        
                                    <el-col :span="11" class="grid-content grid-content_mt">
                                        <el-form-item>
                                            <el-time-select
                                                v-model="form.orders.areas.area_e.time.from"
                                                placeholder="Start time" 
                                                :picker-options="{
                                                    start: '08:00',
                                                    step: '01:00',
                                                    end: '19:00'
                                                }">
                                            </el-time-select>
                                        </el-form-item> 
                                    </el-col>
                                    <el-col :span="2" class="grid-content grid-content_mt"></el-col>
                                    <el-col :span="11" class="grid-content grid-content_mt">
                                        <el-form-item>
                                            <el-time-select
                                                v-model="form.orders.areas.area_e.time.to"
                                                placeholder="End time" 
                                                :picker-options="{
                                                    start: '08:00',
                                                    step: '01:00',
                                                    end: '19:00'
                                                }">
                                            </el-time-select>
                                        </el-form-item> 
                                    </el-col>

                                    <el-col :span="11" class="grid-content grid-content_mt">
                                        <el-form-item prop="orders.areas.area_e.coefficient">  
                                            <el-input-number  
                                                class="form-item__number"
                                                :controls="false"
                                                v-model="form.orders.areas.area_e.coefficient"
                                                placeholder="0.7 coefficient"
                                            ></el-input-number>
                                        </el-form-item> 
                                    </el-col>
                                </div> 
                            </div> 
                        </div>  
                    </el-col> 
                </el-col> 
            </el-row> 
        </el-form>
    </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';

export default { 
    name: 'create-test-form',
    data() {
      return {   
            mastersError: 'in total should be equal to 100',
            ordersError: 'in total should be equal to 100',
            builded: false,
            rules: { 
                'orders.quantity': [
                    {  required: true, message: 'Please input quantity', trigger: 'blur' }, 
                    { type: 'number', min: 5, message: 'Min quantity 5'}
                ],
                'orders.with_two_masters': [
                    {  required: true, message: 'Please input quantity', trigger: 'blur' }, 
                    { type: 'number', min: 1, message: 'Min quantity 1'}
                ], 
                'masters.quantity': [
                    {  required: true, message: 'Please input quantity', trigger: 'blur' }, 
                    { type: 'number', min: 3, message: 'Min quantity 3'}
                ],
                'masters.working_timesheet.date.from': [
                    {  required: true, message: 'Please input date from', trigger: 'blur' }
                ], 
                'masters.working_timesheet.date.to': [
                    {  required: true, message: 'Please input date to', trigger: 'blur' }
                ], 
                'masters.working_timesheet.time.from': [
                    {  required: true, message: 'Please input time from', trigger: 'blur' }
                ], 
                'masters.working_timesheet.time.to': [
                    {  required: true, message: 'Please input time to', trigger: 'blur' }
                ], 
                'orders.duration.from': [
                    {  required: true, message: 'Please input duration from', trigger: 'change' }
                ], 
                'orders.duration.to': [
                    {  required: true, message: 'Please input duration to', trigger: 'change' }
                ], 

                'masters.working_timesheet.not_go_work': [
                    {  required: true, message: 'Please input not go work', trigger: 'blur' }
                ], 
                'orders.carry_over': [
                    {  required: true, message: 'Please input carry over', trigger: 'blur' }
                ],  
                'orders.canceled': [
                    {  required: true, message: 'Please input duration to', trigger: 'blur' }
                ],

                'orders.areas.area_a.percent': [
                    {  required: true, message: 'Please input percent of orders area', trigger: 'blur' }
                ],
                'orders.areas.area_b.percent': [
                    {  required: true, message: 'Please input percent of orders area', trigger: 'blur' }
                ],
                'orders.areas.area_c.percent': [
                    {  required: true, message: 'Please input percent of orders area', trigger: 'blur' }
                ],
                'orders.areas.area_d.percent': [
                    {  required: true, message: 'Please input percent of orders area', trigger: 'blur' }
                ],
                'orders.areas.area_e.percent': [
                    {  required: true, message: 'Please input percent of orders area', trigger: 'blur' }
                ],

                'masters.areas.area_a.percent': [
                    {  required: true, message: 'Please input percent of masters area', trigger: 'blur' }
                ],
                'masters.areas.area_b.percent': [
                    {  required: true, message: 'Please input percent of masters area', trigger: 'blur' }
                ],
                'masters.areas.area_c.percent': [
                    {  required: true, message: 'Please input percent of masters area', trigger: 'blur' }
                ],
                'masters.areas.area_d.percent': [
                    {  required: true, message: 'Please input percent of masters area', trigger: 'blur' }
                ],
                'masters.areas.area_e.percent': [
                    {  required: true, message: 'Please input percent of masters area', trigger: 'blur' }
                ],

                'orders.areas.area_a.coefficient': [
                    {  required: false, trigger: 'blur' },
                    { type: 'number', min: 1.05, message: 'Min quantity 1.05'}
                ],
                'orders.areas.area_b.coefficient': [
                    {  required: false, trigger: 'blur' },
                    { type: 'number', min: 1.05, message: 'Min quantity 1.05'}
                ],
                'orders.areas.area_c.coefficient': [
                    {  required: false, trigger: 'blur' },
                    { type: 'number', min: 1.05, message: 'Min quantity 1.05'}
                ],
                'orders.areas.area_d.coefficient': [
                    {  required: false, trigger: 'blur' },
                    { type: 'number', min: 1.05, message: 'Min quantity 1.05'}
                ],
                'orders.areas.area_e.coefficient': [
                    {  required: false, trigger: 'blur' },
                    { type: 'number', min: 1.05, message: 'Min quantity 1.05'}
                ],
            }
        }
    },
    computed: {
        ...mapGetters({
            form: 'simulation/formGetters',
            showMasterError: 'simulation/showMasterError',
            showOrdersError: 'simulation/showOrdersError'
        }), 
        mastersFifth: {
            get() {
                const master_a = this.form.masters.areas.area_a.percent || 0;
                const master_b = this.form.masters.areas.area_b.percent || 0;
                const master_c = this.form.masters.areas.area_c.percent || 0;
                const master_d = this.form.masters.areas.area_d.percent || 0; 

                const sum = 100 - (master_a + master_b + master_c + master_d); 

                const result = sum > 100 || Math.sign(sum) == -1 ? 0 : sum;
                this.form.masters.areas.area_e.percent = result; 
               
                return result; 
            },
            set() {} 
        },
        ordersFifth: {
            get() {
                const order_a = this.form.orders.areas.area_a.percent || 0;
                const order_b = this.form.orders.areas.area_b.percent || 0;
                const order_c = this.form.orders.areas.area_c.percent || 0;
                const order_d = this.form.orders.areas.area_d.percent || 0; 

                const sum = 100 - (order_a + order_b + order_c + order_d);

                const result = sum > 100 || Math.sign(sum) == -1 ? 0 : sum;
                this.form.orders.areas.area_e.percent = result;

                return result; 
            },
            set() {} 
        },
        mastersPercentSum() {
            const sum = (
                this.form.masters.areas.area_a.percent + this.form.masters.areas.area_b.percent +
                this.form.masters.areas.area_c.percent + this.form.masters.areas.area_d.percent +
                this.form.masters.areas.area_e.percent
            ) === 100; 

            return sum;
        },
        ordersPercentSum() {
            const sum = (
                this.form.orders.areas.area_a.percent + this.form.orders.areas.area_b.percent +
                this.form.orders.areas.area_c.percent + this.form.orders.areas.area_d.percent +
                this.form.orders.areas.area_e.percent
            ) === 100; 

            return sum;
        },
        pickerOptions() {
            return {
                disabledDate(time) {
                    const date = new Date;   
                    return time.getTime() < date - 8.64e7;
                }
            }
        }
    }, 
    methods: {
        ...mapMutations({
            toggleShow: 'preloader/toggleShow',
            clear: 'simulation/clearForm',
            setState: 'simulation/setState'
        }),
        ...mapActions({
            create: 'simulation/create'
        }),  
        changeErrorsState() { 
            this.setState({
                key: 'showMasterError',
                value: true
            }); 

            this.setState({
                key: 'showOrdersError',
                value: true
            }); 
        },
        fillAreas() {
            this.form.orders.areas.area_e.percent = this.ordersFifth;
            this.form.masters.areas.area_e.percent = this.mastersFifth;
        },
        preSubmit() { 
            this.fillAreas(); 
        },
        async validate() {
            return await this.$refs['mainForm'].validate();    
        },
        async onSubmit() {
            try {
                this.preSubmit();
                const isValid = await this.validate(); 
                
                if (!this.mastersPercentSum) {
                    this.setState({
                        key: 'showMasterError',
                        value: true
                    });  
                }

                if (!this.ordersPercentSum) {
                    this.setState({
                        key: 'showOrdersError',
                        value: true
                    }); 
                }

                if (isValid) { 
                    const response = await this.create();  

                    if(response.status == 201) { 
                        this.$router.push({name: 'History'}, () => {
                            this.clear();
                        }); 
                    }    
                    else { 
                        this.$notify({
                            title: 'Server error',
                            message: response.data.message
                        });
                    }
                } 
            } catch (err) {}
        }
    }
}
</script>

<style lang="scss">  
.form {
    width: 100%;  
    background-color: #fff;
    overflow-y: auto;
    height: 90vh;
    flex-wrap: wrap;
    // box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;

    &-box {
        display: flex;
    }

    &__title {
        font-size: 28px;
        margin-bottom: 20px;
    }

    &-left {
        width: 100%;
        // padding: 20px;
        height: 100%;
    }

    &-left {
        padding-right: 3%;
    }

    &-right {
        padding-left: 3%;
    }

    .el-date-editor {
        width: 100% !important;
    }

    h2 {
        margin: 0;
    }

    &__border-bottom {
        padding-bottom: 10px;
        margin-bottom: 10px;
        border-bottom: 1px solid #00000040;
    }

    &__body {
        
    }

    .el-select {
        width: 100%;
    }
}

.mb-0 {
    margin-bottom: 0 !important;
}

.form-item { 
    &__label {
        display: inline-block;
        margin-bottom: 10px;
        font-size: 14px;
        color: #606266;
    }

    &_mb {
        margin-bottom: 16px;
    }

    &_mt {
        margin-top: 49px;
    }

    &__content {
        width: 100%;
        display: flex;

        &_between {
            justify-content: space-between;
        }
    }
    
    &__map {
        width: 100%;
        height: 313px;
        margin-top: 22px;
        margin-bottom: 22.5px;

        img {
            object-fit: contain;
            object-position: left;
        }
    }

    &__multiple {
        display: flex;
    }

    &__wrap {
        flex-wrap: wrap;
    }

    &__number { 
        -webkit-appearance: none;
        background-color: #FFF;
        background-image: none;
        border-radius: 4px; 
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        outline: 0;
        padding: 0;
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        width: 100% !important; 
         
        input {
            text-align: left !important;
        }
    }
}

.grid-content_mt {
    margin-top: 15px;
}
</style>

<style>  
.fill-form .space-between .el-form-item__content {
    display: flex;
    justify-content: space-between !important;
}

.fill-form .el-form-item__label-wrap {
    max-width: 125px;
}

.fill-form .el-form-item__cta {
    display: flex;
    justify-content: flex-start;
    margin-top: 15px;
}

.fill-form  .el-form-item__label { 
    /* line-height: 30px; */
    /* padding: 4px 12px 0 0;  */
}

.el-form-item {
    margin-bottom: 12px !important;
}
</style>